export enum TimeUnit {
  second = 1000,
  minute = 1000 * 60,
  hour = 1000 * 60 * 60,
  day = 1000 * 60 * 60 * 24,
  year = 1000 * 60 * 60 * 24 * 365
}

declare global {
  interface DateConstructor {
    diff: (first: Date, second: Date, unit: TimeUnit) => number;
    isDate: (arg: any) => arg is Date;
    isSameDay: (first: Date, second: Date) => boolean;
    TimeUnit: typeof TimeUnit;
  }

  interface Date {
    diff: (target: Date, unit: TimeUnit) => number;
    isSameDay: (target: Date) => boolean;
  }
}

if (!Date.diff) {
  Object.defineProperty(Date, 'diff', {
    writable: false,
    enumerable: false,
    value: function (first: Date, second: Date, unit: TimeUnit): number {
      return first.diff(second, unit);
    }
  });
}

if (!Date.isDate) {
  Object.defineProperty(Date, 'isDate', {
    writable: false,
    enumerable: false,
    value: (arg: any): arg is Date => {
      return arg instanceof Date;
    }
  });
}

if (!Date.isSameDay) {
  Object.defineProperty(Date, 'isSameDay', {
    writable: false,
    enumerable: false,
    value: (first: Date, second: Date): boolean => {
      return first.isSameDay(second);
    }
  });
}

if (!Date.TimeUnit) {
  Object.defineProperty(Date, 'TimeUnit', {
    writable: false,
    enumerable: false,
    value: TimeUnit
  });
}

if (!Date.prototype.diff) {
  Object.defineProperty(Date.prototype, 'diff', {
    writable: false,
    enumerable: false,
    value: function (this: Date, target: Date, unit: TimeUnit): number {
      return (this.getTime() - target.getTime()) / unit;
    }
  });
}

if (!Date.prototype.isSameDay) {
  Object.defineProperty(Date.prototype, 'isSameDay', {
    writable: false,
    enumerable: false,
    value: function (this: Date, target: Date): boolean {
      return (
        this.getFullYear() === target.getFullYear() &&
        this.getMonth() === target.getMonth() &&
        this.getDate() === target.getDate()
      );
    }
  });
}
